export const SURCHARGE_QUERY = `
query (
  $id: ID!
) {
  surcharge (
    id: $id
  ) {
    id
    company {
      id
      name
    }
    name
    surchargeInCents
    surchargePricingType
  }
}
`

export const SURCHARGE_LIST_QUERY = `
query (
  $filters: [FilterInput]
) {
  surchargeList (
    filters: $filters
  ) {
    id
    name
    surchargeInCents
    surchargePricingType
  }
}
`

export const SURCHARGES_QUERY = `
query (
  $filters: [FilterInput]
  $pageNumber: Int
  $pageSize: Int
  $sorting: [SortingInput]
) {
  surcharges (
    filters: $filters
    pageNumber: $pageNumber
    pageSize: $pageSize
    sorting: $sorting
  ) {
    data {
      id
      company {
        id
        name
      }
      name
      createdAt
      updatedAt
    }
    total
  }
}
`
